module.exports = __webpack_public_path__ + "img/Chevron-Right_24px_2_Icon-light.5d1fb109.svg";